<template>
  <div v-if="hasTiles" class="HowToJoin">
    <TileDisplay
      :title="title"
      :tiles="tilesWithSteps"
      type="benefits"
    />

    <p v-if="hasDisclaimer" class="HowToJoin-disclaimer FootnoteDisclaimer">
      {{ t('custom.landing.howToJoin.disclaimer') }}
    </p>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from '@cvo/i18n/composables/useI18n';
import TileDisplay from '@cvo/ui/components/organisms/TileDisplay/TileDisplay.vue';
import type { HowToJoinProps } from './HowToJoin.model';

const props = defineProps<HowToJoinProps>();

const { t, te } = useI18n();

const hasTiles = computed(() => props.items && props.items.length > 0);
const hasDisclaimer = computed(() => hasTiles.value && te('custom.landing.howToJoin.disclaimer'));

const tilesWithSteps = computed(() => {
  return props.items?.map((item, index) => ({
    ...item,
    step: index + 1,
  })) || [];
});
</script>

<style lang="scss">
@use '@cvo/ui/styles/design-system' as vars;
@use '@cvo/ui/styles/utils/text';

  @layer cvo-ui {
    .HowToJoin {
      .TileDisplay-tile {
        background-color: var(--section-surface-color, #{vars.$molecules-tile-step-bg-color});
      }

      .BenefitTile {

        &-header {
          justify-content: center;
        }
      }

      &-disclaimer {
        @include text.text('sm');
        color: vars.$color-neutral-gray-700;
        margin-top: vars.$dimensions-d-8;
      }
    }
  }
</style>
